import React from "react";

const StarFill = ({ size = 24, color = '#fff' }) => {
    return (
        <svg
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 0 24 24"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m7.625 6.4 2.8-3.625q.3-.4.712-.587Q11.55 1.999 12 2q.45 0 .863.188.412.186.712.587l2.8 3.625 4.25 1.425q.65.2 1.025.737.375.538.375 1.188 0 .3-.087.6-.089.3-.288.575l-2.75 3.9.1 4.1q.025.875-.575 1.475t-1.4.6q-.05 0-.55-.075L12 19.675l-4.475 1.25a1 1 0 0 1-.275.063Q7.1 21 6.975 21q-.8 0-1.4-.6T5 18.925l.1-4.125-2.725-3.875a1.9 1.9 0 0 1-.288-.575Q2 10.05 2 9.75q0-.625.362-1.162.363-.538 1.013-.763zM17 19 4 9.725l16 .05-13 9.2L12 4zL4 9.725l16 .05-13 9.2L12 4z" fill={color} />
        </svg>
    )
}

export default StarFill;